import {get} from 'lodash';

export const getQueryString = state => state.uri.queryString;
export const getQueryParams = state => state.uri.queryParams;

export const getQueryCustomerType = state => {
  return get(state, 'uri.queryParams.customerType') || '';
}



// WEBPACK FOOTER //
// ./src/selectors/uri_selectors.js